import React from 'react';
import Skeleton from '@mui/material/Skeleton';

/**
 * @typedef {Omit<Parameters<typeof Skeleton>[0], 'children'> & {
 *  isLoading: boolean,
 *  children: React.ReactNode
 * }} SkeletonProps
 */

/**
 * @param {SkeletonProps} props - The props object
 * @returns {React.ReactNode} The rendered component
 */
export const SkeletonWrapper = ({ isLoading, children, ...props }) =>
  isLoading ? (
    <Skeleton variant="text" height="fit-content" animation="wave" {...props}>
      {children}
    </Skeleton>
  ) : (
    children
  );
